import PasswordChangeTemplate from "../../templates/PasswordChangeTemplate/PasswordChangeTemplate";

const PasswordChange = () => {
  return <PasswordChangeTemplate />;
};
export default PasswordChange;
